// ==================
// FIREBASE INTERFACE
// ==================
// Ver documentación en:
// https://firebase.google.com/docs/reference/js/

import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import Utils from './utils/Utils';
import DateUtils from './utils/DateUtils';

class FirebaseInterface {
  
  constructor() {
    this.config = UmiCoreConfig;
    this.firebaseApp = firebase.initializeApp(
      this.config,
      `landbot-${this.config.channelToken}-${UmiCoreConfig.test/*false*/ ? 'test' : Utils.randomKey(4)}`
    );
    this.configRef = null;
    this.lastTimestamp = Date.now();
    this.firstTimestamp = Date.now();
    this.callbacks = {};
  }

  // NOT USED
  setConfigRef() {
    this.configRef = this.firebaseApp
      .database()
      .ref(`${this.config.brandID}/public/config/${this.config.channelToken}`);
  }

  auth() {
    return this.firebaseApp.auth().signInAnonymously();
  }

  customerIdentify(customerToken) {
    return new Promise((resolve, reject) => {
      var request = new XMLHttpRequest();
      var formdata = new FormData();
      formdata.append('channel_token', this.config.channelToken);
      // TODO: Probar en back como procesa campos como null
      formdata.append('customer_token', customerToken);

      request.open('POST', this.config.serverUrl + "webchat/get_firebase/");
      request.onload = (oEvent) => {
        // TODO: view request.onerror == 404 (channel not exists)
        const jData = JSON.parse(oEvent.target.response);
        if (request.status == 200) {
          // console.debug(`%cUmiCore debug: Firebase authentication complete ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue');
          let firebaseToken = jData.firebase_token;
          let firebasePath = jData.database_url.split('.com')[1];
          this.lastTimestamp = jData.lastTimestamp * 1000 || this.lastTimestamp;
          this.firstTimestamp = jData.lastTimestamp * 1000 || this.firstTimestamp;

          this.firebaseApp
            .auth()
            .signInWithCustomToken(firebaseToken)
            .catch((err) => {
              reject({
                'code': -1,
                'msg': err
              });
            })
            .then((user) => {
              this.chatRef = this.firebaseApp
                .database()
                .ref(firebasePath);
              this.statBrandRef = this.firebaseApp
                .database()
                .ref(firebasePath.split('/')[0] + '/presence');
              this.typingRef = this.firebaseApp
                .database()
                .ref(firebasePath.substring(0, firebasePath.lastIndexOf("messages")) + "typing");
              resolve(user);
            });
        } 
        else if(request.status == 403){
           reject({'code':2,'msg':jData.error});
           return ;
        } 
        else {
          reject({'code':1,'msg':jData.error});
           return ;
        }
      }
      request.onerror = function(oEvent) {
        reject({ 'code': 0, 'msg': 'Server connection error'});
      }
      request.send(formdata);
    });
  }

  setEventListener(event, callback) {
    this.callbacks[event] = callback;
  }

  updateFirstTimestamp(timestamp) {
    if (this.firstTimestamp > timestamp)
      this.firstTimestamp = timestamp - 0.001;
  }

  startConnection(newCustomer) {
    // Infalible nene
    let lastKey = null;
    let ignoreFirst = false;

    let customRef = this.chatRef
      // .orderByKey();
      .orderByChild("timestamp");

    customRef
      .limitToLast(1)
      .once('value')
      .then((messageSnapshot) => {
        const obj = messageSnapshot.toJSON() ?
          messageSnapshot.toJSON() : { timestamp: 0 };
        // lastKey = Object.keys(obj)[0];
        lastKey = Object.values(obj)[0].timestamp;
        if (lastKey && !newCustomer) {
          ignoreFirst = true;
          customRef = customRef
            .startAt(lastKey);
        }

        customRef
          .on('child_added', (messageSnapshot) => {
            if (ignoreFirst === true) {
              ignoreFirst = false;
            } else {
              this.onChildAdded(messageSnapshot);
            }
          });
      });
  }

  onChildAdded(messageSnapshot) {
    let message = messageSnapshot.toJSON();
    message.key = messageSnapshot.key;
    this.callbacks['addMessage'](message);
  }

  getAllMessages(limit = 20) {
    return new Promise((resolve,reject) => {
      const query = this.chatRef
        .orderByChild("timestamp")
        .limitToLast(limit)
        .once('value')
        .then((messageSnapshot) => {
          let listmessage = [];
          messageSnapshot.forEach((message) => {
            let auxmessage = message.toJSON();
            auxmessage.key = message.key;
            listmessage.push(auxmessage);
          });
          if (listmessage.length > 0 ) {
            // this.lastTimestamp = listmessage[listmessage.length - 1].timestamp + 0.001;
            this.updateFirstTimestamp(listmessage[0].timestamp);
          }
          resolve(listmessage);
        })
        .catch((error) => reject(error));
    });
  }

  getOldChats(datelimit,limit=20){
    return new Promise((resolve,reject) => {
      const query = this.chatRef
        .orderByChild("timestamp")
        .endAt(this.firstTimestamp)
        .limitToLast(limit)
        .once('value')
        .then((messageSnapshot) => {
          let listmessage = [];
          messageSnapshot.forEach((message) => {
            let auxmessage = message.toJSON();
            auxmessage.key = message.key;
            listmessage.push(auxmessage);
          });
          if (listmessage.length > 0) {
            // this.lastTimestamp = listmessage[listmessage.length - 1].timestamp + 0.001;
            this.updateFirstTimestamp(listmessage[0].timestamp);
          }
          resolve(listmessage);
        })
        .catch((error) => reject(error));
    });
  }

  getAgentData(agentID) {
    return new Promise((resolve, reject) => {
      var request = new XMLHttpRequest();
      request.open('POST', this.config.serverUrl + "webchat/get_agent/");
      request.onload = (oEvent)=>{
        const jData = JSON.parse(oEvent.target.response);
        if (request.status == 200) {
          resolve(jData);
        }
        else if(request.status == 403){
           reject({'code':2, 'msg':jData.error});
           return ;
        } 
        else {
          reject({'code':1, 'msg':jData.error});
           return ;
        }
      }
      request.onerror = function(oEvent) {
        reject({'code':0, 'msg':'Server connection error'});
      }
      request.send(JSON.stringify({
        agent_id: agentID,
        channel_token: this.config.channelToken,
      }));
    })
  }
}

export default FirebaseInterface;


// WEBPACK FOOTER //
// ../UmiCore/src/FirebaseInterface.js